import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BarsOutlinedSvg from "@ant-design/icons-svg/es/asn/BarsOutlined";
import AntdIcon from "../components/AntdIcon";
var BarsOutlined = function BarsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BarsOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BarsOutlined.displayName = 'BarsOutlined';
}
export default /*#__PURE__*/React.forwardRef(BarsOutlined);